import { useQuery } from '@tanstack/react-query'

import { getStoreByDomain, type GetStoreByDomainOptions } from '@flecto/api/store'

type QueryPayload = {
  storeDomain: string
  options?: GetStoreByDomainOptions
}

export function useQueryGetStoreByDomain({
  storeDomain,
  options,
}: QueryPayload) {
  return useQuery({
    queryKey: ['QueryGetStoreByDomain', storeDomain],
    queryFn: async () => await getStoreByDomain(storeDomain, options),
  })
}
